const initialState={
	categorias:[],
	categoriasEstado:0	
};

export default function categoriaReducer(state= initialState,action){
	switch(action.type){
		case 'CATEGORIAS':
     		return {...state,categorias:action.payload};
     	case 'CATEGORIAS_ESTADO':
     		return {...state,categoriasEstado:action.payload};
     	default:
     		return state
	}
}